const EXCLUDED_PATH_PATTERNS = [
  '.svg',
  '.png',
  '.webp',
  '.js',
  '.ico',
  '/giris',
  '/uye/kisisel-bilgilerim/hesabimi-sil',
  '/parola-guncelle',
  '/parola-unuttum',
  '/parola-unuttum/sonuc',
];

export const isExcluded = (pathname: string) => EXCLUDED_PATH_PATTERNS.some((p) => pathname.includes(p));
